/* global femcare */

femcare.general.accordion = {
    init: function(selector, heightStyle) {
        var $accordions = $(selector);
        if ($accordions.length) {
            var toggleIconSelector = '.accordion__toggle-icon';
            var expandedClass = 'accordion__toggle-icon--expanded';
            $accordions.accordion({
                header: '.accordion__header',
                beforeActivate: function(event, ui) {
                    $(ui.oldHeader)
                        .find(toggleIconSelector)
                        .toggleClass(expandedClass);
                    $(ui.newHeader)
                        .find(toggleIconSelector)
                        .toggleClass(expandedClass);
                },
                collapsible: true,
                active: false,
                heightStyle: heightStyle || 'auto'
            });
        }
    }
};
